import React, { Fragment, useContext, useEffect, useLayoutEffect, useState } from "react";
import { AppContext, paymentCfg } from "../../components/AppProvider";
import {
  PostApi1972,
  PostApi1973,
  PostApi227,
} from "../../modules/network/padoPost";
import { closeLayerFn, openLayerFn } from "../Layout";
import {
  BackgroundDiv,
  BottomBtn,
  CaptureBtn,
  CaptureBtnArea,
  CardErr,
  CardName,
  CardNum,
  ContentBody,
  HeaderTitle,
  ListDiv,
  NoticeText,
  SettingBtn,
  Warapper,
} from "../Nftf/Receipt/ReceiptStyle";

import { Base64 } from "js-base64";
import styled from "styled-components";
import { ConfirmLayer } from "../../components/UI/Dialog";
import { payment } from "../../modules/payments/payments";
import { _O } from "../../modules/utils";
import { ExclamationCircleSrc } from "../../resources/Assets";
import CardIcon from "../../resources/CardIcon";
import ArrowLeft from "../../resources/images/nftf/arrow-left.svg";
import DeleteCard from "../../resources/images/nftf/cardList/deleteCard.svg";
import Plus from "../../resources/images/nftf/plus.svg";
import ReceiptIframe from "../Nftf/Receipt/ReceiptIframe";
import { CardListDefault } from "./CardListCpnt/CardListDefault";
import { CardListErr } from "./CardListCpnt/CardListErr";

const CardManager = (props) => {
  const { cardInfo } = props;
  const getData = JSON.parse(Base64.decode(props.match.params.dataInfo));
  const { userinfo, cfg, phonecfg } = useContext(AppContext);

  const [loading, setLoading] = useState(true);

  const [moveUrl, setMoveUrl] = useState();
  const [pageIdx, setPageIdx] = useState(0);

  const [manageMode, setManageMode] = useState(false);
  const [cardList, setCardList] = useState();
  const [deleteTarget, setDeleteTarget] = useState();

  const [cardTemp, setCardTemp] = useState(null);

  const returnUrl = cfg.nftfReturnUrl;

  const postUrl = `${cfg.url}app/pg/payment?appUrl=${encodeURIComponent(
    location.origin + returnUrl
  )}&userToken=${userinfo.userToken}`;

  const REACT_APP_MALL_ID = paymentCfg.batchMallId;

  const [webpayParams, setWebayparams] = useState({
    mallId: REACT_APP_MALL_ID,
    payMethodTypeCode: "81",
    currency: "00",
    amount: 0,
    clientTypeCode: "00",
    returnUrl: postUrl,
    shopOrderNo: userinfo.userToken,
    deviceTypeCode: "mobile",
    orderInfo: { goodsName: "비대면진료비" },
    payMethodInfo: {
      billKeyMethodInfo: {
        certType: "0",
      },
    },
  });

  const getMyCardList = () => {
    PostApi1972(userinfo, cfg, phonecfg)
      .then((res) => {
        setCardList(res.result);

        if (!cardInfo && res.result.length > 0) {
          setCardTemp(res.result[0]);
        }

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  // 다이얼로그 [[
  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
  });

  const handleConfirmDialog = (title, msg, seqNo) => {
    setDialog({
      title: title,
      msg: msg,
    });

    setDeleteTarget(seqNo);
    openLayerFn($(".confirm-layer"));
  };

  const deleteCard = () => {
    PostApi1973(userinfo, cfg, phonecfg, deleteTarget)
      .then((res) => {
        if (cardList.length === 1) {
          // setCardInfo(null);
          setCardTemp(null);
        }
        getMyCardList();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleCancelCB = () => {
    closeLayerFn($(".confirm-layer"));
  };

  useLayoutEffect(() => {
    if (loading) {
      getMyCardList();
      setManageMode(false);
    }
  }, [loading]);

  useEffect(() => {
    window.addEventListener("message", (e) => {
      if (e.data.messageId === "reload") {
        // 수신 후 처리
        setPageIdx(0);
        setLoading(true);
      }
    });
  }, []);

  const RePay = () => {
    if (cardTemp && cardTemp.errChkYn === "N") {
      PostApi227(userinfo, cfg, phonecfg, getData.appID, cardTemp.seqNo)
        .then((res) => {
          if (res.rsltCd === "E000") {
            _O.Open("/resrvList");
          } else {
            alert(res.rsltMsg);
            getMyCardList();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      alert("결제할 카드를 선택하세요");
    }
  };

  return (
    <Fragment>
      <ConfirmLayer
        priv="priv"
        title={dialog.title}
        msg={dialog.msg}
        handleCancelCB={handleCancelCB}
        handleConfirmCB={deleteCard}
      />

      {pageIdx === 9 ? (
        <ReceiptIframe setPageIdx={setPageIdx} moveUrl={moveUrl} />
      ) : (
        <BackgroundDiv>
          <HeaderTitle>
            <div
              style={{ width: "40px", height: "40px" }}
              onClick={() => window.history.back()}>
              <img src={ArrowLeft} />
            </div>
            <div>결제수단선택</div>
            <div style={{ width: "40px", height: "40px" }}>
              {/* <img src={ArrowLeft} /> */}
            </div>
          </HeaderTitle>
          <ContentBody>
            <NoticeText>
              진료비 결제카드를
              <br />
              선택해 주세요
            </NoticeText>

            <CaptureBtnArea style={{ maxHeight: "35vh", overflow: "auto" }}>
              {cardList &&
                cardList.map((data, i) =>
                  data.errChkYn === "N" ? (
                    <CardListDefault
                      key={"cardTemp" + i}
                      idx={i}
                      cardInfo={data}
                      setCardInfo={setCardTemp}
                      manageMode={manageMode}
                      selectCardData={cardInfo}
                      handleConfirmDialog={handleConfirmDialog}
                      // checkedOption={i === 0 ? true : false}
                      checkedOption={false}
                    />
                  ) : (
                    <CardListErr
                      key={"cardTemp" + i}
                      idx={i}
                      cardInfo={data}
                      setCardInfo={setCardTemp}
                      manageMode={manageMode}
                      selectCardData={cardInfo}
                      handleConfirmDialog={handleConfirmDialog}
                      // checkedOption={i === 0 ? true : false}
                      checkedOption={false}
                    />
                  )
                )}
            </CaptureBtnArea>
            <CaptureBtnArea>
              <CaptureBtn
                onClick={() =>
                  payment(
                    userinfo,
                    cfg,
                    phonecfg,
                    setMoveUrl,
                    setPageIdx,
                    webpayParams
                  )
                }>
                <img src={Plus} style={{ width: "14px", height: "14px" }} />{" "}
                결제수단 추가
              </CaptureBtn>
              <SettingBtn onClick={() => setManageMode(!manageMode)}>
                결제수단 관리
              </SettingBtn>
            </CaptureBtnArea>
          </ContentBody>

          {!manageMode ? (
            <Fragment>
              <div
                style={{
                  position: "absolute",
                  bottom: "96px",
                  margin: " 0 20px",
                  display: "flex",
                }}>
                <img
                  src={ExclamationCircleSrc}
                  style={{ width: "20px", height: "20px" }}
                />
                <div>
                  진료비{" "}
                  <font color="#6A62E6">
                    {(
                      parseInt(getData.amount) + parseInt(getData.cmsnAmt)
                    ).toLocaleString("ko-KR", 0)}
                    원
                  </font>
                  을 결제합니다
                </div>
              </div>
              <BottomBtn onClick={() => RePay()}>재결제</BottomBtn>
            </Fragment>
          ) : (
            <BottomBtn onClick={() => setManageMode(!manageMode)}>
              변경 저장
            </BottomBtn>
          )}
        </BackgroundDiv>
      )}
    </Fragment>
  );
};

const CardTemp = (props) => {
  const {
    manageMode,
    cardInfo,
    setCardInfo,
    selectCardData,
    idx,
    handleConfirmDialog,
    checkedOption,
  } = props;

  const [active, setActive] = useState(
    selectCardData ? (selectCardData.seqNo == cardInfo.seqNo ? true : false) : checkedOption
  );

  const toggleEvent = () => {
    setCardInfo(cardInfo);
  };

  return (
    <Warapper disabledStatus={cardInfo.errChkYn === "Y" ? true : false}>
      <input
        type={manageMode ? "checkbox" : "radio"}
        name="cardList"
        id={"cardList" + cardInfo.seqNo}
        onClick={() =>
          manageMode
            ? handleConfirmDialog("", "선택한 카드를 삭제하시겠습니까?", cardInfo.seqNo)
            : toggleEvent()
        }
        defaultChecked={active}
        hidden
      />
      <ListDiv htmlFor={"cardList" + cardInfo.seqNo}>
        <div>
          <CardIcon cardInfo={cardInfo} />
        </div>
        <div>
          <CardName
            // disabledStatus={true}
            active={manageMode ? false : $("#cardList" + cardInfo.seqNo).prop("checked")}
          >
            {cardInfo.cardNm}
          </CardName>
          <div style={{ display: "flex", gap: "8px" }}>
            <CardNum active={manageMode ? false : $("#cardList" + cardInfo.seqNo).prop("checked")}>
              {cardInfo.cardNo}
            </CardNum>

            {cardInfo.errChkYn === "Y" && (
              <CardErr
                active={manageMode ? false : $("#cardList" + cardInfo.seqNo).prop("checked")}
              >
                결제실패
              </CardErr>
            )}
          </div>
        </div>
        {manageMode && <img src={DeleteCard} style={{ marginLeft: "auto" }} />}
      </ListDiv>
      <CardErrMsgDiv>{cardInfo.cardRsltMsg}</CardErrMsgDiv>
    </Warapper>
  );
};

const CardErrMsgDiv = styled.div`
  display: flex;
  width: 288px;
  padding: 8px 16px;
  align-items: flex-start;
  gap: 10px;
  border-radius: 6px;
  background: #fafafa;
  color: #888;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
`;

export default CardManager;
